<template>
  <div class="container-table-striped">
    <div class="table-hover">
      <table class="table content-table-striped table-striped mb-5">
        <thead>
          <tr class="row global-thead-dark thead-property pl-1">
            <th class="col-4">
              Acomodos
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="row">
            <td class="col-md-12">
              <div id="accordionMeasurement">
                <div class="card-pei">
                  <div class="card-header">
                    <div class="mb-0">
                      <div
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        <div class="accordion-header-container">
                          <BadgeModal
                            i="fas fa-plus orange-icon"
                            title="Solicitar Acomodos"
                          />
                          <span
                            class="close-border p-1 mr-2 mt-0 float-right"
                            @click="close"
                          >
                            <i class="fas fa-window-close close-ico" />
                            Cerrar
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="collapseOne"
                    class="collapse show"
                    aria-labelledby="headingOne"
                    data-parent="#accordionMeasurement"
                  >
                    <div class="card-body">
                      <CustomDropDown
                        v-model="selectedArea"
                        placeholder="Seleccione área"
                        label="Áreas:"
                        fieldkey="id"
                        fieldname="name"
                        :options="areaList"
                        class="w-50 mb-3"
                        @input="filterMeasurements"
                      />
                      <MultiSelectionPicker
                        :all-items="measurements"
                        item-type-name="Objeto"
                        :modify-removes-item="true"
                        placeholder="Escriba aquí para buscar una área académica"
                        id-prop-name="id"
                        text-prop-name="name"
                        @itemSelected="itemSelectedHandler"
                      />
                      <span class="multiple-selection-title">
                        *Selección múltiple
                      </span>
                      <div class="row mb-4">
                        <div class="col">
                          <div
                            v-if="added.length > 0"
                            class="accommodation-box"
                          >
                            <p>Acomodos seleccionados</p>
                            <BadgeTitle
                              v-for="item in added"
                              :key="item.id"
                              :class="'col'"
                              :title="item.name"
                              :highlight="item.highlight"
                              @delete="deleteClick(item)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="float-right">
                <button
                  id="save"
                  class="btn bold btn-green pt-1 mb-3"
                  @click="save"
                >
                  Guardar
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import CustomDropDown from '@/components/common/CustomDropDown';
import MultiSelectionPicker from '@/components/common/MultiSelectionPicker';
import { BadgeTitle } from '@/components/pei/shared';
import BadgeModal from '@/components/common/page/badge/BadgeModal';

export default {
  name: 'MeasurementProgramStudentAdd',
  data() {
    return {
      selectedArea: null,
      added: [],
    };
  },
  props: {
    areaList: {
      type: Array,
      default: () => [],
      required: true,
    },
    measurements: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  methods: {
    itemSelectedHandler(item) {
      this.added.push({ id: item.id, name: item.name, highlight: true });
    },
    save() {
      this.$emit('on-save', {});
    },
    close() {
      this.$emit('close');
    },
    deleteClick(item) {
      this.added.splice(this.added.indexOf(item), 1);
      this.$emit('unselect-item', { ...item });
    },
    filterMeasurements(selectedArea) {
      this.$emit('fecthMeasurements', selectedArea);
    },
  },
  components: {
    CustomDropDown,
    MultiSelectionPicker,
    BadgeTitle,
    BadgeModal,
  },
};
</script>

<style scoped>
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}
.close-border {
  border: 1px solid #2db782;
  border-radius: 50px;
  display: inline-block;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.6em;
  text-align: center;
  width: 7.1875rem;
  height: 2.6875‬rem;
  cursor: pointer;
  color: #2db782;
}

.accommodation-box {
  background: #fafbfa 0% 0% no-repeat padding-box;
  border-radius: 0px 5px 5px 0px;
  opacity: 1;
  margin-top: 40px;
}
.multiple-selection-title {
  text-align: left;
  font: Regular 14px/21px Lato;
  letter-spacing: 0;
  color: #b5c3bc;
  opacity: 1;
}
</style>
